/** Registration — always Luma */
export const LUMA_REGISTRATION_URL = "https://luma.com/v36q6jr4";

export const HACKATHON = {
    title: "Agentic Hack: Payments & Robots",
    themeLabel: "Payments & Robots",
    tagline: "One day. Build payments or robots that work.",
    buildBrief:
        "Two tracks, one hack: payments — agents and flows that move money on real rails (M-Pesa, cards, wallets, partner APIs like PayHero) — and robots — bots, autonomous systems, hardware, sensors, and anything in the IoT stack. Combine them or pick a lane; show a live demo that works.",
    dateLabel: "September 2026",
    dateIso: "2026-09-01",
    location: "To be announced — TBA",
    host: "Build Bout",
    heroCardNote: "Limited seats",
    heroImage:
        "https://posthog-cyan.vercel.app/events/uoe-hackathon.png",
};

export const PRIZE_POOL = {
    headline: "~KES 100,000",
    subline: "in cash prizes across the podium and special awards",
    tiers: [
        {
            place: "Grand Prize",
            amount: "KES 40,000",
            detail: "Best end-to-end payments or robotics build with a live demo",
        },
        {
            place: "Runner-up",
            amount: "KES 30,000",
            detail: "Strong real-world use case and polished working prototype",
        },
        {
            place: "3rd Place",
            amount: "KES 20,000",
            detail: "Original idea with a working hardware or software integration",
        },
        {
            place: "Best Agentic Flow",
            amount: "KES 5,000",
            detail: "Clearest agent + payments or bot orchestration",
            accent: true,
        },
        {
            place: "Best Demo",
            amount: "KES 5,000",
            detail: "Most compelling live pitch and product story",
            accent: true,
        },
    ],
};

export const SCHEDULE_INTRO =
    "Pre activity: we restore degraded dryland together before hackathon day. On the main day: snacks on arrival, streamlined presentations and judging — build before you arrive, then come ready to demo payments, robots, or both.";

/** Pre activity runs before hackathon day (community restoration, not a second competition day). */
export const SCHEDULE_DAYS = [
    {
        id: "pre-activity",
        label: "Pre activity",
        tagline:
            "Community restoration before hackathon day — not a second competition day.",
        items: [
            {
                time: "Pre activity",
                title: "Reforest degraded dryland",
                detail:
                    "Hands-on planting at a selected dryland site. Help restore native cover, meet other builders, and give back before the main event.",
                accent: true,
            },
        ],
    },
    {
        id: "hackathon",
        label: "Day 1 — Hackathon day",
        tagline: "Presentations, judging, and prizes",
        items: [
            {
                time: "08:00",
                title: "Check-in",
                detail: "Snacks provided on arrival. Meet mentors and your team.",
            },
            {
                time: "08:30",
                title: "Kick-off & rules",
                detail: "Format, judging criteria, and payments & robots brief.",
            },
            {
                time: "09:00",
                title: "Streamlined presentations",
                detail: "Quick team intros and problem statements — no build sprint on site.",
            },
            {
                time: "10:00",
                title: "Judging begins",
                detail: "Early demos and evaluation start before lunch.",
            },
            {
                time: "13:00",
                title: "Lunch & progress",
                detail: "Refuel and share how far each project has come.",
            },
            {
                time: "15:00",
                title: "Final demos",
                detail: "Last pitches; judges finalize scores through the afternoon.",
            },
            {
                time: "18:00",
                title: "Winners announced",
                detail: "Prizes, photos, and closing on stage.",
            },
        ],
    },
];

/** @deprecated Use SCHEDULE_DAYS — kept for any legacy imports */
export const SCHEDULE = SCHEDULE_DAYS[1].items;

export const JUDGING = [
    "Does it work? Live payments, agent flow, robot, or IoT demo beats slides.",
    "Does it solve something real for Kenyan users or businesses?",
    "Is the payments + robots story clear and original?",
    "Could this product grow — market, compliance, reliability, and scale?",
    "Can you tell the story in 3 minutes?",
];

export const SPONSOR_TIERS = [
    {
        name: "Title sponsor",
        perks: [
            "Logo on stage, stream, and all comms",
            "Opening remarks slot (3 min)",
            "Judge seat + recruiting table",
        ],
    },
    {
        name: "Gold",
        perks: [
            "Logo on website & event materials",
            "Mentor office hours block",
            "Swag in participant kits",
        ],
    },
    {
        name: "Community partner",
        perks: [
            "Logo on website",
            "Shared social announcement",
            "In-kind perks for builders",
        ],
    },
];

/** Edit names/logos here; logos live in public/sponsors/ */
export const SPONSORS = [
    {
        name: "PayHero",
        tag: "Payments partner",
        logo: "/sponsors/payhero.png",
    },
    { name: "Build Bout", tag: "Host" },
    { name: "Your logo here", tag: "Sponsor slot" },
];

export const SPONSOR_CONTACT_EMAIL = "chidi@cheppar.co.ke";
